import { type CallbacksOptions } from 'next-auth';

import { AuthProviders } from '../types';

export const singInAuthHandler: CallbacksOptions['signIn'] = ({ user }) => {
  return !!user;
};

export const jwtAuthHandler: CallbacksOptions['jwt'] = ({
  user,
  account,
  token,
}) => {
  const returnToken = token;
  const isMartins = account?.provider === AuthProviders.MARTINS_CRED;
  const isRefreshToken = account?.provider === AuthProviders.REFRESH_TOKEN;
  const isFabrica = account?.provider === AuthProviders.FABRICA_CRED;

  if (user) {
    returnToken.role = typeof user.role === 'string' ? user.role : null;
  }

  if (isMartins && user.token) {
    returnToken.token = user.token;
  }

  if (isMartins || isRefreshToken) {
    returnToken.token = user.token;
    returnToken.serviceToken = user.serviceToken;
    returnToken.refreshToken = user.refreshToken;
    returnToken.registration = user.registration;
    returnToken.projects = user.projects;
    returnToken.manufacturerId = user.manufacturerId;
  }

  if (isFabrica) {
    returnToken.serviceToken = user.serviceToken;
    returnToken.refreshToken = user.refreshToken;
    returnToken.registration = user.registration;
    returnToken.projects = user.projects;
    returnToken.manufacturerId = user.manufacturerId;
    returnToken.firstAccess = user.firstAccess;
  }

  return returnToken;
};

export const sessionAuthHandler: CallbacksOptions['session'] = ({
  session,
  token,
}) => {
  const returnSession = { ...session };

  if (token) {
    returnSession.t = {
      // mt: token.token ? token.token : returnSession.t?.mt,
      st: token.serviceToken,
      rt: token.refreshToken,
    };
    returnSession.user = {
      ...returnSession.user,
      registration: token.registration
        ? token.registration
        : returnSession.user?.registration,
      role: typeof token.role === 'string' ? token.role : null,
      projects: token.projects ? token.projects : null,
      manufacturerId: token.manufacturerId,
      firstAccess: token.firstAccess,
    };
  }

  return returnSession;
};
